// extracted by mini-css-extract-plugin
export default {"requirements":"ConditionsFulfillment_requirements__5OWdI"};